import DateTime from "../Components/DateTime";
import React, { useState, useRef, useEffect } from "react";
import 'react-quill/dist/quill.snow.css'
import MainButton from "../Props/MainButton";
import ModalBoxMaster from "../Props/ModalBoxMaster";
import Loader from "../../Inventory/Props/Loader";
import ItemMaster from "../../API/APIServices/ItemMaster";
import TransactionCustomizeDelete from "./CustomizeDeleteTabs/TransactionCustomizeDelete";
import AccountCustomizeDelete from "./CustomizeDeleteTabs/AccountCustomizeDelete";
import ItemCustomizeDelete from "./CustomizeDeleteTabs/ItemCustomizeDelete";
import AccountGroupCustomizeDelete from "./CustomizeDeleteTabs/AccountGroupCustomizeDelete";
import ItemGroupCustomizeDelete from "./CustomizeDeleteTabs/ItemGroupCustomizeDelete";

function CustomizeDelete() {
    /***********title***************/
    useEffect(() => {
        document.title = 'Customize Delete';
    }, []);

    const [loading, setLoading] = useState(false);
    const [tab, setTab] = useState(1);


    const SaveBtn = () => {


    }

    return (
        <div>
            {/* < PageTabs />

            < ModalBoxMaster /> */}

            <div style={{zIndex: 10}} className="panel-heading">
                <div className="panel-head-title">
                    <h2 className="panel-title">Customize Delete</h2>
                </div >

                {/* *******************Top Buttons****************** */}

                <MainButton saveButtonHide={true} />

            </div>
            <div>
                {/* < DateTime /> */}
            </div>
            <div className="content_box">
                <div className="company-info-top-im">
                    <div className="tab-head">
                        <div id="tabs">

                            <div className="tab-btn-box">

                                <div onClick={() => setTab(1)} className={`tab  ${tab === 1 ? "active" : ""}`}>
                                    Transaction
                                </div>

                                <div onClick={() => setTab(2)} className={`tab  ${tab === 2 ? "active" : ""}`}>
                                    Account
                                </div>

                                <div onClick={() => setTab(3)} className={`tab  ${tab === 3 ? "active" : ""}`}>
                                    Account Group
                                </div>

                                <div onClick={() => setTab(4)} className={`tab  ${tab === 4 ? "active" : ""}`}>
                                    Item
                                </div>

                                <div onClick={() => setTab(5)} className={`tab  ${tab === 5 ? "active" : ""}`}>
                                    Item Group
                                </div>

                            </div>

                            {tab == 1 && (
                                <TransactionCustomizeDelete setLoading={setLoading} />
                            )}

                            {tab == 2 && (
                                <AccountCustomizeDelete setLoading={setLoading} />
                            )}

                            {tab == 3 && (
                                <AccountGroupCustomizeDelete setLoading={setLoading} />
                            )}

                            {tab == 4 && (
                                <ItemCustomizeDelete setLoading={setLoading} />
                            )}

                            {tab == 5 && (
                                <ItemGroupCustomizeDelete setLoading={setLoading} />
                            )}



                            {/* <div className="tab-content-1">

                                <div className="company-info-top-left" >
                                    <div className="company_info-text-im">Left</div>

                                    <div className="HeadContentInputBpx">

                                        <div className="input-box-m11">
                                            <input className="modify_im_input mode_limit mode_category" type="text" />
                                            <label class="modifyTextLabel">Student Full Name&nbsp;<span className="StarClr">*</span></label>
                                        </div>


                                    </div>
                                </div>

                                <div className="company-info-top-right" >


                                    <div className="company_info-text-im">Student Details</div>
                                    <div className="HeadContentInputBpx">

                                        <div className="input-box-m11">
                                            <input className="modify_im_input mode_limit mode_category" type="text" />
                                            <label class="modifyTextLabel">Student Full Name&nbsp;<span className="StarClr">*</span></label>
                                        </div>


                                    </div>


                                </div>


                            </div> */}

                        </div>
                    </div>
                </div>
                <div>
                    <div className="buttom-box">
                        <div className="button-btn-2">
                            <button className="btn-2" onClick={() => window.location.reload()}>Reset</button>
                        </div>
                    </div>
                </div>
            </div>
            {loading && <Loader />}
        </div >
    );
}
export default CustomizeDelete;
